import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("animate-pulse motion-reduce:animate-none rounded-md bg-primary/10", className)}
      {...props} />
  );
}

export { Skeleton }
